import { Box, Typography } from "@mui/material";

const MultiTextRender = (text: Array<string | number>) => {
  return (
    <Box display="flex" flexDirection={"column"}>
      {text.map((item, index) => (
        <Typography key={index}>{item}</Typography>
      ))}
    </Box>
  );
}
export default MultiTextRender;
